import React from 'react';

export default {
  showErrorTemplate: function showErrorTemplate({ shippingModel, isResponseFetched }) {
    let isErrorTemplate = false;
    if ((!shippingModel
        || !shippingModel.shipModes
        || shippingModel.shipModes.length === 0)
        && isResponseFetched
    ) {
      isErrorTemplate = true;
    }
    return isErrorTemplate;
  },
  isTemplateToRender: function isTemplateToRender({ model }) {
    let isRenderTemplates = false;
    if ((model?.shipModes?.length > 0)) {
      isRenderTemplates = true;
    }
    return isRenderTemplates;
  },
};